export default __webpack_public_path__ + "static/media/x-white.d01d5253.svg";